import React, { useEffect, useState, useMemo, useRef, forwardRef, useImperativeHandle } from "react";
import { AuthNetworkLayer, persistAuthTokens, PolicyHelper } from "helpers";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { setLoading, setLoadingMessage } from "globals/overlays";
import { Formik, Form, Field } from "formik";
import UpdatedModal from "components/misc/Modal-V2";
import jwtDecoder from "jwt-decode";
import { Row, Col } from "reactstrap";
import "./otp.scss";
import { object, string } from "yup";
import HoverZoomLayeredImage from "./HoverZoomLayeredImage";
import {
  setRenewablePolicies,
  getUser,
  getToken,
  login,
  getUserFormData,
  getUserId,
  setCurrentUser,
  setPolicies,
  setExtendablePolicies,
  setCoverNotePolicies,
  getTransactionType,
  setActivePolicies,
  setHasMotorPolicies,
  setHasHomePolicies,
  setHasLiabilitiesPolicies,
} from "globals/auth";
import {
  enrichPoliciesWithPaymentPlan,
  getAuthErrorMessage,
  getExtendablePoliciesPaymentPlan,
  getNewGlobalToken,
  isPolicyManagerBrokerAccessMessage,
} from "helpers/auth";
import { PAY_BALANCE, RENEWAL } from "pages/RenewPolicy/constants";
import { ERROR } from "../Modal-V2/constants";
import InfoIcon from "../InfoIcon";
import { useScreenType } from "globals/screenTypeHook";
import { clearPolicyManager } from "globals/policymanager";
import { setClaimsForTracking, setClaimsStatuses } from "globals/claims";
import { clearStoreOnLogin } from "globals/misc";
import { getAllClaimStatus, getClaims } from "api/dNet/Claims";
import FloatingLabelInput from "components/NewFloatingLabel/FloatingLabelInput";
import logger from "utils/logger";
import { persistor } from "../../../globals";
const { testIds } = require("testing/testIds");
const MailIcon = "/assets/img/contact-icons/mail-3.png";
const PhoneIcon = "/assets/img/payment_form_icons/phone-call.svg";
const VehicleIcon = "/assets/img/vehicle_management_icons/vehicle_management_vehicle_icon.svg";
const otpImage = "/assets/img/otp-image.svg";

const defaultFormValues = {
  policyNum: "",
  chassisNum: "",
  licenseNum: "",
  globalName: "",
};

function OTP({ isClaims = false, isTrackAClaim = false, isPayBalance = false, isPolicyManager = false }) {
  const transactionType = useSelector(getTransactionType);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector(getUser);
  const userFormData = useSelector(getUserFormData);
  const userId = useSelector(getUserId);
  const token = useSelector(getToken);

  const [val, setVal] = useState("");
  const [open, openModal] = useState(false);
  const [modalError, setModalError] = useState("");
  const [currentMethod, setCurrentMethod] = useState("");

  const [otherFormValid, setOtherFormValid] = useState(false);
  const [otherFormDirty, setOtherFormDirty] = useState(false);

  const search = location?.search || "";
  const tokenParam = useMemo(() => {
    const params = new URLSearchParams(search);
    return params.get("t");
  }, [search]);

  const { isMobile, width } = useScreenType();

  const closeModal = () => openModal(false);

  const setValue = (val) => setVal(val);

  const otherFormRef = useRef(null);

  async function validateMaidenName(value) {
    let error;
    if (!value) return (error = "Mother's Maiden name is required");
    return error;
  }

  const checkPoliciesForDepartmentClass = (policies, departmentClass) => {
    return policies.some(policy => policy.department_class === departmentClass);
  };

  const getClaimStatus = async () => {
    try {
      const claimsStatuses = await getAllClaimStatus();
      dispatch(setClaimsStatuses(claimsStatuses.response));
    } catch (e) {
      logger.log(e);
    }
  };

  const fetchClaims = async policies => {
    let i;
    const newClaimsArray = [];
    for (i = 0; i < policies?.length; i++) {
      dispatch(setLoadingMessage(`Loading policy details: ${policies?.length - (i + 1)} policies remaining`));
      const payload = {
        policy_id: policies[i]?.policy_id,
      };

      const retrievedClaims = await getClaims(payload);

      if (!retrievedClaims?.success) continue;

      newClaimsArray.push(...retrievedClaims.claims);
    }
    return newClaimsArray;
  };

  /**
   * Handles the submission of the form
   * @param {defaultFormValues} values
   */
  const handleOtherSubmit = async (values, actions) => {
    let hasMotorPolicies = false;
    let hasHomePolicies = false;
    let hasLiabilityPolicies = false;

    dispatch(setLoadingMessage("Authenticating User"));
    dispatch(setLoading(true));

    try {
      let response;
      let count = 2;
      let _token = token;

      while (count > 0) {
        response = await AuthNetworkLayer.alternateVerification(
          isClaims,
          isPolicyManager,
          userId, // change with the otp thing
          values?.licenseNum?.trim(),
          values?.policyNum?.trim(),
          values?.chassisNum?.trim(),
          userFormData?.national_id,
          values?.globalName?.trim(),
          transactionType,
          userFormData?.is_a_company,
          isTrackAClaim
        );

        if (!response.success && response.message?.includes("status code 401")) {
          _token = (await getNewGlobalToken(3)).token;
          --count;
        } else {
          count = -1;
        }
      }

      if (!response.success)
        throw new Error(
          "Oops! We do not have this information. Please contact our Telebranch at (888) 687-2442"
        );

      /** @type {Object} */
      const data = jwtDecoder(response.data);

      // Clear all state AFTER successful authentication but BEFORE setting new user data
      dispatch(clearStoreOnLogin());
      // Purge persisted storage to ensure no cached data remains
      await persistor.purge();

      let fetchedClaims = [];
      if (isTrackAClaim) {
        let statuses = await getClaimStatus();

        fetchedClaims = [...(await fetchClaims(data?.policies))];
      }

      if (fetchedClaims?.length) dispatch(setClaimsForTracking(fetchedClaims));

      persistAuthTokens(data);
      dispatch(setCurrentUser(data.user));

      hasMotorPolicies = checkPoliciesForDepartmentClass(data?.policies, "Motor");
      hasHomePolicies = checkPoliciesForDepartmentClass(data?.policies, "Fire");
      hasLiabilityPolicies = checkPoliciesForDepartmentClass(data?.policies, "Liability");

      dispatch(setHasMotorPolicies(hasMotorPolicies));
      dispatch(setHasHomePolicies(hasHomePolicies));
      dispatch(setHasLiabilitiesPolicies(hasLiabilityPolicies));

      const filteredPolicies = data.policies.filter(policy => policy.department_class !== "Liability");

      if (isClaims) {
        dispatch(setPolicies(PolicyHelper.filterForClaims(filteredPolicies)));
        isTrackAClaim ? history.push("/track-my-claim/claim-listing") : history.push("/claims/contact-info");
      } else if (transactionType === PAY_BALANCE) {
        dispatch(setPolicies(data.policies));
        let extendablePolices = await getExtendablePoliciesPaymentPlan(filteredPolicies, token);
        dispatch(setExtendablePolicies(PolicyHelper.filterForExtension(extendablePolices)));
        history.replace(`/${PAY_BALANCE}/contact-info` /* "/renewal/policy-listing" */);
      } else if (isPolicyManager) {
        // Preserve the full non-liability policy set for scoped selectors like Documents Center.
        dispatch(setPolicies(filteredPolicies));

        const filteredPoliciesForPolicyManager = filteredPolicies.filter(policy => policy.department_class !== "Fire");
        const activeAndRenewable = PolicyHelper.findAllActiveAndRenewablePolicies(filteredPoliciesForPolicyManager);
        const enrichedPolicies = await enrichPoliciesWithPaymentPlan(activeAndRenewable);
        dispatch(setActivePolicies(enrichedPolicies));

        dispatch(clearPolicyManager());
        history.push("/manage-your-policy/policy-editor");
      } else {
        dispatch(setRenewablePolicies(PolicyHelper.filterForRenewal(filteredPolicies)));
        history.replace("/renewal/contact-info" /* "/renewal/policy-listing" */);
      }
      dispatch(login());
    } catch (e) {
      setModalError(e.message);
      openModal(true);
    } finally {
      dispatch(setLoading(false));
      actions?.setSubmitting(false);
    }
  };

  const handleSubmit = async () => {
    dispatch(setLoading(true));

    try {
      if (currentMethod === "email" || currentMethod === "phone") {
        // generate token and send email
        // need it for here
        const choice = { method: currentMethod, contact: currentMethod === "phone" ? val : user.email_address };
        let response = await AuthNetworkLayer.sendOTP(
          `${user.first_name || user.last_name || userFormData.company_name}`,
          { [currentMethod]: choice.contact },
          userId,
          userFormData.national_id,
          token
        );

        if (!response.success) throw new Error(response.message);
        if (isTrackAClaim) {
          history.push("/track-my-claim/otp-verification", choice);
        } else if (transactionType === RENEWAL) history.push("/renewal/otp-verification", choice);
        else if (transactionType === PAY_BALANCE) history.push("/paybalance/otp-verification", choice);
        else if (isPolicyManager) history.push("/manage-your-policy/otp-verification", choice);
        else history.push("/claims/otp-verification", choice);
      }
    } catch (e) {
      setModalError(e.message);
      openModal(true);
    } finally {
      dispatch(setLoading(false));
    }
  };

  const setMethod = e => {
    setCurrentMethod(e.target.value);
  };

  // Validation schemas (unchanged)
  const renewalFormSchema = object().shape({
    policyNum: string().required("Policy Number is required").matches(/^\d{1,7}$/, "Please enter a valid policy number"),
    licenseNum: string()
      .required("License Number is required")
      .matches(/^(?:\d{4}[A-Z]{1,2}|[A-Z]{2}\d{4}|CD\d{4}|CC\d{4}|FO\d{4})$/i, "License Number is invalid"),
  });

  const claimsFormSchema = object().shape({
    policyNum: string().required("Policy Number is required").matches(/^\d{1,7}$/, "Please enter a valid policy number"),
    licenseNum: string()
      .required("License Number is required")
      .matches(/^(?:\d{4}[A-Z]{1,2}|[A-Z]{2}\d{4}|CD\d{4}|CC\d{4}|FO\d{4})$/i, "License Number is invalid"),
    globalName: string().required("Mother's Maiden name is required"),
  });

  const managePolicyFormSchema = object().shape({
    policyNum: string().required("Policy Number is required").matches(/^\d{1,7}$/, "Please enter a valid policy number"),
    licenseNum: string()
      .required("License Number is required")
      .matches(/^(?:\d{4}[A-Z]{1,2}|[A-Z]{2}\d{4}|CD\d{4}|CC\d{4}|FO\d{4})$/i, "License Number is invalid"),
  });

  const managePolicyFormSchema2 = object().shape({
    policyNum: string().required("Policy Number is required").matches(/^\d{1,7}$/, "Please enter a valid policy number"),
    chassisNum: string().required("Chassis Number is required"),
  });

  const isOther = currentMethod?.includes("other");
  const isMethodSelected = !!currentMethod;

  return (
    <div className="otp-page-wrapper" data-testid={testIds.auth.otp.page.container}>
      <div className="otp-container">
        {/* Decorative background blobs */}
        <div className="blob top-right" />
        <div className="blob bottom-left" />

        <div className="otp-split-layout">
          {/* LEFT SIDE – Illustration + Brand message */}
          <div className="left-panel">
            <div>
              <HoverZoomLayeredImage
                background="/assets/img/login/otp/methods/background.svg"
                foreground="/assets/img/login/otp/methods/foreground.svg"
                zoomScale={1.1}
                zoomZ={80}
              />

              <div className="brand-message">
                <h2>Secure & Simple Verification</h2>
                <p>
                  Protecting your account is our top priority. Verify your identity in seconds using your preferred method.
                </p>
              </div>
            </div>

          </div>

          {/* RIGHT SIDE – Form */}
          <div className="right-panel">
            <div className="form-content">
              <div className="header-section">
                <span className="security-badge">
                  <img
                    src="/assets/img/login/renewalLogin/lock.svg"
                    alt=""

                  /> Security Check
                </span>
                <h1>Verify it's you</h1>
                <p>Select a verification method below to receive your One-Time Password (OTP).</p>
              </div>

              <UpdatedModal
                modalType={ERROR}
                title={isPolicyManagerBrokerAccessMessage(modalError) ? "Access Not Authorized" : "Record Not Found"}
                showModal={open}
                primaryLabel="OK"
                primaryCallback={closeModal}
              >
                {modalError}
              </UpdatedModal>

              <div className="method-options" data-testid={testIds.auth.otp.methods.container}>
                {/* Phone options */}
                {user?.phone_numbers?.filter((p) => p.use_for_sms).map((phone, i) => (
	                  <label
	                    key={phone.value + i}
	                    className={`method-card ${currentMethod === "phone" && val === phone.value ? "selected" : ""}`}
	                    data-testid={testIds.auth.otp.methods.smsOption}
	                    onClick={() => {
                      setMethod({ target: { value: "phone" } });
                      setValue(phone.value);
                    }}
                  >
	                    <div className="radio-outer">
	                      <div className={`radio-inner ${currentMethod === "phone" && val === phone.value ? "checked" : ""}`} />
	                    </div>
                    <div className="method-content">
                      <div className="method-label-row">
                        <span className="method-title">SMS Verification</span>
                        <img src="/assets/img/login/otp/phone.svg" alt="" className="method-icon" style={{ width: 20, height: 20 }} />
                      </div>
                      <div className="method-desc">
                        {phone.carrier}: {phone.value}
                        {/* <InfoIcon label="A verification code will be sent to this phone number." /> */}
                      </div>
                    </div>
                  </label>
                ))}

                {/* Email */}
                {user?.email_address && (
                  <label
                    className={`method-card ${currentMethod === "email" ? "selected" : ""}`}
                    data-testid={testIds.auth.otp.methods.emailOption}
                    onClick={() => {
                      setMethod({ target: { value: "email" } });
                      setValue(user.email_address);
                    }}
                  >
                    <div className="radio-outer">
                      <div className={`radio-inner ${currentMethod === "email" ? "checked" : ""}`} />
                    </div>
                    <div className="method-content">
                      <div className="method-label-row">
                        <span className="method-title">Email Verification</span>
                        <img src="/assets/img/login/otp/mail.svg" alt="" className="method-icon" style={{ width: 20, height: 20 }} />
                      </div>
                      <div className="method-desc">
                        {user.email_address}
                        {/* <InfoIcon label="A verification code will be sent to this email address." /> */}
                      </div>
                    </div>
                  </label>
                )}

                {/* ── Normal / Renewal / Claims flow ── */}
                {!isPolicyManager && !isTrackAClaim && (
                  <div className={`method-card-expandable ${currentMethod === "other" ? "selected expanded" : ""}`}
                    data-testid={testIds.auth.otp.methods.otherOption}
                    onClick={() => currentMethod !== "other" && setCurrentMethod("other")}
                  >
                    <div className={`expandle-method-card expandable`}>

                      <div className="radio-outer">
                        <div className={`radio-inner ${currentMethod === "other" ? "checked" : ""}`} />
                      </div>

                      <div className="method-content">
                        <div className="method-label-row">
                          <span className="method-title">Other Verification</span>
                          <img src="/assets/img/login/otp/car.svg" alt="" className="method-icon" style={{ width: 20, height: 20 }} />
                        </div>

                        <div className="method-desc">
                          {!userFormData?.is_a_company
                            ? "Policy # & Plate Number"
                            : "Policy # & Plate Number"}
                          {/* <InfoIcon label="Additional identity verification required." /> */}
                        </div>

                      </div>


                    </div>
                    {currentMethod === "other" && (
                      <OtherVerificationForm
                        ref={otherFormRef}
                        variant="other"
                        initialValues={defaultFormValues}
                        onSubmit={handleOtherSubmit}
                        isClaims={isClaims}
                        isCompany={userFormData?.is_a_company}
                        motherMaidenNameExists={user?.mother_maiden_name !== ""}
                        onValidityChange={(valid, dirty) => {
                          setOtherFormValid(valid);
                          setOtherFormDirty(dirty);
                        }}
                      />
                    )}
                  </div>
                )}

                {/* ── Policy Manager – Vehicle Registration ── */}
                {isPolicyManager && (
                  <div className={`method-card-expandable ${currentMethod === "other-reg-no" ? "selected expanded" : ""}`}
                    onClick={() => currentMethod !== "other-reg-no" && setCurrentMethod("other-reg-no")}
                  >
                    <div
                      className={`expandle-method-card expandable`}
                    >
                      <div className="radio-outer">
                        <div className={`radio-inner ${currentMethod === "other-reg-no" ? "checked" : ""}`} />
                      </div>

                      <div className="method-content">
                        <div className="method-label-row">
                          <span className="method-title">Vehicle Registration</span>
                          <img src="/assets/img/login/otp/car.svg" alt="" className="method-icon" style={{ width: 20, height: 20 }} />
                        </div>

                        <div className="method-desc">
                          Verify via Policy & Plate Number
                          {/* <InfoIcon label="This option requires confirmation of your policy # and registration plate #." /> */}
                        </div>


                      </div>
                    </div>
                    {currentMethod === "other-reg-no" && (
                      <OtherVerificationForm
                        ref={otherFormRef}
                        variant="other-reg-no"
                        initialValues={defaultFormValues}
                        onSubmit={handleOtherSubmit}
                        isClaims={isClaims}
                        isCompany={userFormData?.is_a_company}
                        motherMaidenNameExists={false}
                        onValidityChange={(valid, dirty) => {
                          setOtherFormValid(valid);
                          setOtherFormDirty(dirty);
                        }}
                      />
                    )}
                  </div>
                )}

                {/* ── Policy Manager – Chassis Number ── */}
                {isPolicyManager && (
                  <div className={`method-card-expandable ${currentMethod === "other-chassis-no" ? "selected expanded" : ""}`}
                    onClick={() => currentMethod !== "other-chassis-no" && setCurrentMethod("other-chassis-no")}
                  >
                    <div
                      className={`expandle-method-card expandable `}

                    >
                      <div className="radio-outer">
                        <div className={`radio-inner ${currentMethod === "other-chassis-no" ? "checked" : ""}`} />
                      </div>

                      <div className="method-content">
                        <div className="method-label-row">
                          <span className="method-title">Chassis Number</span>
                          <img src="/assets/img/login/otp/chassis.svg" alt="" className="method-icon" style={{ width: 20, height: 20 }} />
                        </div>

                        <div className="method-desc">
                          Verify via Chassis Number
                          {/* <InfoIcon label="This option requires confirmation of your policy # and chassis #." /> */}
                        </div>

                      </div>
                    </div>
                    {currentMethod === "other-chassis-no" && (
                      <OtherVerificationForm
                        ref={otherFormRef}
                        variant="other-chassis-no"
                        initialValues={defaultFormValues}
                        onSubmit={handleOtherSubmit}
                        isClaims={isClaims}
                        isCompany={userFormData?.is_a_company}
                        motherMaidenNameExists={false}
                        onValidityChange={(valid, dirty) => {
                          setOtherFormValid(valid);
                          setOtherFormDirty(dirty);
                        }}
                      />
                    )}
                  </div>
                )}


              </div>

              <div className="submit-area">
                <button
                  type="button"
                  className={`submit-btn ${isOther ? "main w-full max-w-md mx-auto" : ""}`}
                  data-testid={isOther ? testIds.auth.otp.actions.submitVerificationButton : testIds.auth.otp.actions.sendCodeButton}
                  onClick={() => {
                    if (isOther) {
                      if (otherFormRef.current) otherFormRef.current.submit();
                      return;
                    }
                    handleSubmit();
                  }}
                  disabled={!isMethodSelected}
                >
                  <span>{isOther ? "Submit Verification" : "Send Verification Code"}</span>
                  <span>
                    <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18.7071 8.07039C19.0976 7.67986 19.0976 7.0467 18.7071 6.65617L12.3431 0.292213C11.9526 -0.0983109 11.3195 -0.0983109 10.9289 0.292213C10.5384 0.682738 10.5384 1.3159 10.9289 1.70643L16.5858 7.36328L10.9289 13.0201C10.5384 13.4107 10.5384 14.0438 10.9289 14.4343C11.3195 14.8249 11.9526 14.8249 12.3431 14.4343L18.7071 8.07039ZM0 7.36328L0 8.36328L18 8.36328V7.36328V6.36328L0 6.36328L0 7.36328Z" fill="white" />
                    </svg>
                  </span>
                </button>

                <p className="support-link">
                  Can't access these methods?{" "}
                  <span onClick={() => {
                    if (window.$crisp) {
                      window.$crisp.push(['do', 'chat:open']);
                    } else {
                      logger.log("Crisp not loaded");
                    }
                  }}>Contact Support</span>
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const OtherVerificationForm = forwardRef(({
  variant,                      // "other" | "other-reg-no" | "other-chassis-no"
  initialValues,
  onSubmit,
  isClaims,
  isCompany,
  motherMaidenNameExists,
  onValidityChange,             // callback to report isValid & dirty to parent
}, ref) => {
  const formikRef = useRef();
  const hiddenSubmitRef = useRef(null); // Ref to hidden submit button
  const wrapperRef = useRef(null); // wrapper ref

  // ── Scroll into view when this form mounts ──────────────────────────────
  useEffect(() => {
    if (wrapperRef.current) {
      wrapperRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }, []); // runs once on mount

  useImperativeHandle(ref, () => ({
    isValid: () => formikRef.current?.isValid ?? false,
    isDirty: () => formikRef.current?.dirty ?? false,
    submit: () => {
      if (hiddenSubmitRef.current) {
        hiddenSubmitRef.current.click(); // Triggers native form submit
      }
    },
  }));
  // Choose correct schema based on variant
  let validationSchema;

  if (variant === 'other-chassis-no') {
    validationSchema = object().shape({
      policyNum: string()
        .required('Policy Number is required')
        .matches(/^\d{1,7}$/, 'Please enter a valid policy number'),
      chassisNum: string()
        .required('Chassis Number is required')
        .min(5, 'Chassis Number is too short'),
    });
  } else if (variant === 'other-reg-no' || variant === 'other') {
    validationSchema = object().shape({
      policyNum: string()
        .required('Policy Number is required')
        .matches(/^\d{1,7}$/, 'Please enter a valid policy number'),
      licenseNum: string()
        .required('License Plate Number is required')
        .matches(/^[A-Za-z0-9]+$/i, 'License Plate Number is invalid'),
      ...(variant === 'other' && isClaims && !isCompany && motherMaidenNameExists
        ? { globalName: string().required("Mother's Maiden Name is required") }
        : {}),
    });
  }

  const showMaidenName = variant === 'other' && isClaims && !isCompany && motherMaidenNameExists;

  return (<div ref={wrapperRef}>
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      validateOnMount={true}          // Validate right away on mount
      validateOnChange={true}
      validateOnBlur={true}
    >
      {({
        values,
        errors,
        touched,
        setFieldValue,
        setFieldTouched,
        isSubmitting,
        isValid,
        dirty,
        handleSubmit,
      }) => {
        // Report current validity & dirty state to parent whenever they change
        useEffect(() => {
          if (onValidityChange) {
            onValidityChange(isValid, dirty);
          }
        }, [isValid, dirty, onValidityChange]);

        return (
          <Form className="embedded-form" onSubmit={handleSubmit}>
            <div className="embedded-form-fields">
              <FloatingLabelInput
                id="policyNum"
                label="Policy Number *"
                value={values.policyNum}
                data-testid={testIds.auth.otp.form.policyNumberInput}
                onChange={(e) => {
                  setFieldValue('policyNum', e.target.value.trim());
                }}
                onBlur={() => setFieldTouched('policyNum', true)}
                error={touched.policyNum && errors.policyNum}
                touched={touched.policyNum}
              />

              {variant === 'other-chassis-no' ? (
                <FloatingLabelInput
                  id="chassisNum"
                  label="Chassis Number *"
                  value={values.chassisNum}
                  data-testid={testIds.auth.otp.form.chassisNumberInput}
                  onChange={(e) => {
                    setFieldValue('chassisNum', e.target.value.trim().toUpperCase());
                  }}
                  onBlur={() => setFieldTouched('chassisNum', true)}
                  error={touched.chassisNum && errors.chassisNum}
                  touched={touched.chassisNum}
                />
              ) : (
                <FloatingLabelInput
                  id="licenseNum"
                  label="License Plate Number *"
                  value={values.licenseNum}
                  data-testid={testIds.auth.otp.form.licenseNumberInput}
                  onChange={(e) => {
                    setFieldValue('licenseNum', e.target.value.trim().toUpperCase());
                  }}
                  onBlur={() => setFieldTouched('licenseNum', true)}
                  error={touched.licenseNum && errors.licenseNum}
                  touched={touched.licenseNum}
                />
              )}
            </div>

            {showMaidenName && (
              <div className="mt-1">
                <FloatingLabelInput
                  id="globalName"
                  label="Mother's Maiden Name *"
                  value={values.globalName}
                  onChange={(e) => {
                    setFieldValue('globalName', e.target.value);
                  }}
                  onBlur={() => setFieldTouched('globalName', true)}
                  error={touched.globalName && errors.globalName}
                  touched={touched.globalName}
                />
              </div>
            )}


            {/* Hidden submit button — this is what we click programmatically */}
            <button
              type="submit"
              ref={hiddenSubmitRef}
              style={{ display: 'none' }}
              disabled={isSubmitting}
            >
            </button>
          </Form>
        );
      }}
    </Formik>
  </div>
  );
}
);

export default OTP;
